import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Bahrain: Country = {
    identifier: "Bahrain",
    name: "Bahrain",
    countryCode: "BH",
    group: CountryGroup.ASIA,
    isUNMember: true,
    flag: "🇧🇭",
    svgPath: "m 616.92475,388.1464 -0.091,0.237 -0.087,-0.083 -0.22,-0.41 0.066,-0.288 -0.103,-0.412 0.049,-0.118 0.264,-0.055 0.061,0.018 -0.079,0.132 0.146,0.23 0.022,0.379 z",
}
